<template lang="jade">
  .container-fluid.frame
    //- .mask(v-if="isMobile")
    //-   h2 Please rotate your mobile.
    .row
      //- .col-md-12(style="padding-top:40px;")
        span {{ww}} {{wh}}
        span {{isMobile}}
      .col-md-12.no_pad.frame_group
        iframe#iframe(v-bind:src="iframeSrc")
</template>
<script>
import MobileDetect from 'mobile-detect'
import $ from 'jquery'
// const MOBILE_HEADER_HEIGHT = 40

export default {
  data: () => ({
    iframeSrc: '',
    ww: 0,
    wh: 0
  }),
  computed: {
    isMobile () {
      let md = new MobileDetect(window.navigator.userAgent)
      return md.mobile() !== null && this.wh > this.ww
    }
  },
  methods: {
    addListener () {
      let md = new MobileDetect(window.navigator.userAgent)
      setTimeout(() => {
        this.ww = window.innerWidth
        this.wh = window.innerHeight
        // console.log('ww', this.ww)
        // console.log('wh', this.wh)
        // console.log('ww percentage', this.ww / 1337)
        // console.log('wh percentage', this.wh / 1337)
        if (window.matchMedia('(orientation: landscape)').matches && md.mobile() !== null) {
          console.log('landscape')
          let body = document.getElementById('iframe').contentWindow.document.getElementsByTagName('body')
          // let html = document.getElementById('iframe').contentWindow.document.getElementsByTagName('html')
          let innerWindow = document.getElementById('iframe').contentWindow

          // let innerSidebar = document.getElementById('iframe').contentWindow.document.getElementsByClassName('sidebar')

          // The iframe is too high for some reason so set it to fit the window
          $('#iframe').height(window.innerHeight - 40)
          $('#iframe').width(this.ww)
          $('#iframe').css({
            'height': (window.innerHeight - 40) + 'px',
            'width': this.ww + 'px',
            'outline': '5px solid #000',
            'outline-offset': '-5px'
          })

          $(innerWindow).css({
            ouline: '5px solid #f00',
            'outline-offset': '-5px'
          })

          let scale = 1
          if (this.ww < 1337) {
            scale = this.ww / 1337
          }
          console.log(this.ww)
          console.log('scale in iframe.vue', scale)

          // transform the inner html
          $(body).css({
            'outline': '5px solid #0f0',
            'transform': `scale(${scale})`,
            'transform-origin': 'top left',
            'width': this.ww / (this.ww / 1337),
            'height': '1337px',
            // 'height': (this.wh - MOBILE_HEADER_HEIGHT) / this.ww * 1337 + 'px',
            'overflow-x': 'hidden'
          })

          // // Compute and set the bar height to make it fit the window
          // $(innerSidebar).css({
          //   'height': (this.wh - MOBILE_HEADER_HEIGHT) / this.ww * 1337 + 'px'
          // })
          // let vue = this
          // $(innerWindow).scroll(function (e) {
          //   let y = $(innerWindow).scrollTop() / (vue.ww / 1337)
          //   $(innerSidebar).css({
          //     'transform': `translateY(${y}px)`
          //   })
          // })
        }
      }, 500)
    }
  },
  ready () {
    this.iframeSrc = `/ite/?mac=${this.$route.params.mac}`
    this.ww = window.innerWidth
    this.wh = window.innerHeight
    // window.addEventListener('orientationchange', this.addListener, false)
    // this.addListener()
  },
  route: { // add these code to index of every type of devices to reload data
    canReuse: false, // can't reuse so forces it to reload data
    activate ({next}) {
      next()
    },
    deactivate (transition) {
      // window.removeEventListener('orientationchange', this.addListener, false)
      // window.removeEventListener('resize', this.addListener, false)
      transition.next()
    }
  }
}
</script>

<style lang='scss' scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';

.frame{
  margin-top: -40px;
  padding-top: 10px;
  height: 100vh;
  .row{
    height: 100%;
    .frame_group{
      height: 100%;
      padding-top: 31px;
      // overflow-y: scroll;
      // overflow-x: hidden;
      position: relative;
      // add following to enable mobile touch
      -webkit-overflow-scrolling:touch;
    }
  }
}
#iframe{
  width: 100%;
  height: 100%;
  border: none;
  overflow: hidden;
  // position: absolute;
  outline: 4px solid #f00;
}

.mask{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  left: 0;
  text-align: center;
  line-height: 100%;
  background-color: $base-black;
  color: $base-white;
  & h2{
    position: fixed;
    margin-top: 30%;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// iframe.vue?3e9d822c